import React from 'react';
import _get from 'lodash.get';
import { format, lastDayOfMonth } from 'date-fns';
import {
  Container,
  Row,
  Col,
  RadioButton,
  Text,
  NumberChanger,
  Dropdown,
  Divider,
  Input,
  FeatureToolTip,
  LabelWrapper,
  Switch,
  Icon,
  ToolTip } from
'../../../ui-kit';

const reasons = [
{ value: 'Purchase', label: 'Purchase' },
{ value: 'Refund', label: 'Refund' },
{ value: 'Special', label: 'Special' },
{ value: 'Other', label: 'Other' }];


const today = new Date();
const currentMonth = format(today, 'MMM');
const lastDateOfMonth = format(lastDayOfMonth(today), 'dd MMM, yyyy');

const mapProjectLabel = (projects) => projects.map(({
  resourceType,
  resourceName,
  resourceId,
  type,
  value
}) => ({
  resourceType,
  type,
  value,
  resourceId,
  suffix: `${value || 0} Credits`,
  label: resourceName
}));

































export default function AdjustCreditsSection({
  organisationId,
  detailedView,
  toggleDetailedView,
  usedCredits,
  selectedBucket,
  onChangeTeamRecurring,
  setThisMonthOnly,
  setTopUp,
  recurringMonthly,
  originalRecurringMonthly,
  thisMonthOnly,
  originalThisMonthOnly,
  topUp,
  workspaceCredits,
  workspaceTopUpCredits,
  hasChangesApartFromRecurring,
  teamsOnly,
  shouldAdjustProject,
  toggleShouldAdjustProject,
  setSelectedProjectForAdjustment,
  changeRequest,
  setChangeRequest,
  getProjectsConsumption,
  isWsFreeTier,
  isInternalMode = false,
  wsRecurringVal,
  teamBufferLimit,
  workspaceRecurringBalance,
  allTeamsBalances
}) {
  const fetchProjects = async (keyword) => {
    if (!keyword) {return [];}

    if (selectedBucket?.teamId) {
      const [
      teamsProjectCreditConsumption,
      teamsProjectTopUpConsumption] =
      await Promise.all([
      getProjectsConsumption({
        organisationId,
        resourceType: 'PRO',
        resourceOwner: 'TEAM',
        type: 'WORKSPACE|CREDITS',
        resourceKeyword: keyword
      }),
      getProjectsConsumption({
        organisationId,
        resourceType: 'PRO',
        resourceOwner: 'TEAM',
        type: 'WORKSPACE|TOPUP_CREDITS',
        resourceKeyword: keyword
      })]
      );
      const consumedCreditsForTeams = _get(teamsProjectCreditConsumption, 'data.getContractItemConsumptionByResourceType', []);
      const consumedTopUpForTeams = _get(teamsProjectTopUpConsumption, 'data.getContractItemConsumptionByResourceType', []);

      const allProjectCredits = consumedCreditsForTeams.map((t) => {
        const resourceForTeamsTopUp = consumedTopUpForTeams.
        find((teamTopUp) => teamTopUp.resourceId === t.resourceId) || {};

        return {
          ...t,
          value: Number(resourceForTeamsTopUp.value || 0) + Number(t.value || 0)
        };
      });

      return mapProjectLabel(allProjectCredits);
    }

    const [
    wsProjectCreditConsumption,
    wsProjectTopUpConsumption] =
    await Promise.all([
    getProjectsConsumption({
      organisationId,
      resourceType: 'PRO',
      resourceOwner: 'WORKSPACE',
      type: 'WORKSPACE|CREDITS',
      resourceKeyword: keyword
    }),

    getProjectsConsumption({
      organisationId,
      resourceType: 'PRO',
      resourceOwner: 'WORKSPACE',
      type: 'WORKSPACE|TOPUP_CREDITS',
      resourceKeyword: keyword
    })]
    );

    const consumedCreditsForWorkspace = _get(wsProjectCreditConsumption, 'data.getContractItemConsumptionByResourceType', []);
    const consumedTopUpForWorkspace = _get(wsProjectTopUpConsumption, 'data.getContractItemConsumptionByResourceType', []);

    const allProjectCredits = consumedCreditsForWorkspace.map((t) => {
      const resourceForWorkspaceTopUp = consumedTopUpForWorkspace.
      find((wsTopUp) => wsTopUp.resourceId === t.resourceId) || {};

      return {
        ...t,
        value: Number(t.value || 0) + Number(resourceForWorkspaceTopUp.value || 0)
      };
    });

    return mapProjectLabel(allProjectCredits);
  };

  const displayedWorkspaceCredits = workspaceCredits === Infinity ?
  'Unlimited' :
  workspaceCredits -
  usedCredits.usageOfWorkspaceCredits -
  usedCredits.usageOfThisMonthOnlyCredits;

  const displayedTopUpCredits = workspaceTopUpCredits - usedCredits.usageOfTopUpCredits;

  const teamBufferConsumption = selectedBucket.teamId && selectedBucket.bufferRemaining ?
  teamBufferLimit - selectedBucket.bufferRemaining :
  0;

  const {
    thisMonthOnlyConsumption,
    topupCreditConsumption,
    recurringConsumption,
    thisMonthOnlyRecurringConsumption
  } = selectedBucket;
  const {
    allTopUpCredits,
    allThisMonthOnlyCreditConsumption,
    allThisMonthOnlyCreditBalance,
    allTopupCreditConsumption
  } = allTeamsBalances;
  const isThisMonthOnlyDecrementDisabled = selectedBucket.teamId ?
  thisMonthOnly === thisMonthOnlyConsumption + thisMonthOnlyRecurringConsumption :
  thisMonthOnly === Math.max(thisMonthOnlyConsumption,
  allThisMonthOnlyCreditConsumption + allThisMonthOnlyCreditBalance
  );

  const topupCreditDecrementDisabled = selectedBucket.teamId ?
  topUp === topupCreditConsumption :
  topUp === Math.max(topupCreditConsumption,
  allTopupCreditConsumption + allTopUpCredits
  );

  const isMaxRecurringForTeam = Number(recurringMonthly) ===
  Number(workspaceRecurringBalance) + Number(originalRecurringMonthly);


  return (
    <>
      <Text heading5 className="adjust-credits__period">
        {isInternalMode ? `Period 1 ${currentMonth} to ${lastDateOfMonth}` : 'Configuration'}
      </Text>

      <div className="adjust-credits">
        {isInternalMode &&
        <div className="adjust-credits__value-row">
            <Text heading5>
              Adjust Credits
            </Text>
            <Text
            link
            className="adjust-credits__value-row__show-detailed">

              <span
              role="button"
              tabIndex={0}
              onClick={toggleDetailedView}
              onKeyDown={null}>

                {detailedView ? 'Hide Detailed' : 'Show Detailed'}
              </span>
            </Text>
          </div>}


        <div className="adjust-credits__credit-values">
          {selectedBucket.teamId && isInternalMode &&
          <Text className="adjust-credits__credit-values__title">
              Workspace credits are required to assign to a team
            </Text>}

        </div>

        {isInternalMode && !selectedBucket.teamId &&
        <div className="adjust-credits__value-row">
            <Text>
              Recurring Monthly
              <FeatureToolTip
              iconName="info"
              iconColor="regent"
              iconSize={12}
              preferPlace="right">

                <Text heading5>Recurring Monthly</Text>
                <Text>
                  Renewable credits that are part of your subscription
                  that is assigned to this team every month.
                </Text>
              </FeatureToolTip>
            </Text>
            <div className="adjust-credits__value-row__block">
              {wsRecurringVal === Infinity ? 'Unlimited' : wsRecurringVal}
            </div>
          </div>}


        {selectedBucket.teamId &&
        <div className="adjust-credits__value-row">
            <Text>
              Recurring Monthly
              <FeatureToolTip
              iconName="info"
              iconColor="regent"
              iconSize={12}
              preferPlace="right">

                <Text heading5>Recurring Monthly</Text>
                <Text>
                  Renewable credits that are part of your subscription
                  that is assigned to this team every month.
                </Text>
              </FeatureToolTip>
            </Text>
            <div className="adjust-credits__value-row__alert">
              {recurringMonthly <= teamBufferConsumption && recurringMonthly !== 0 &&
            <ToolTip
              id="recurring-alert-tooltip"
              label="Cannot reduce recurring monthly credits below credit advance owed."
              place="left">

                <div className="adjust-credits__value-row__alert__icon">
                  <Icon name="alert" color="goldenTainoi" size={20} className="alert-icon" />
                </div>
              </ToolTip>}

              {recurringMonthly !== 0 &&
            Number(recurringMonthly) !== Number(originalRecurringMonthly) &&
            isMaxRecurringForTeam &&

            <ToolTip
              id="recurring-alert-tooltip"
              label="Increment disabled as team recurring credits are more than available workspace recurring credits"
              place="left">

                  <div className="adjust-credits__value-row__alert__icon">
                    <Icon name="alert" color="goldenTainoi" size={20} className="alert-icon" />
                  </div>
                </ToolTip>}

              <NumberChanger
              value={recurringMonthly}
              onChangeNumber={onChangeTeamRecurring}
              disableTextInput
              disabled={isWsFreeTier || workspaceCredits === Infinity}
              decrementDisabled={
              recurringMonthly === 0 ||
              recurringMonthly <= teamBufferConsumption ||
              recurringMonthly <= Math.max(recurringConsumption,
              thisMonthOnlyRecurringConsumption
              )}

              maxDisabled={Number(displayedWorkspaceCredits) <= 0 || isMaxRecurringForTeam} />

            </div>
          </div>}


        <div className="adjust-credits__value-row">
          <Text>
            This Month Only
            <FeatureToolTip
              iconName="info"
              iconColor="regent"
              iconSize={12}
              preferPlace="right">

              <Text heading5>This Month Only</Text>
              <Text>
                Renewable credits that are part of your subscription
                that is assigned for this month only.
                Recurring monthly can only be managed in subscriptions.
              </Text>
            </FeatureToolTip>
          </Text>
          <div className="adjust-credits__value-row__alert">
            {selectedBucket.teamId &&
            Number(thisMonthOnly) !== Number(originalThisMonthOnly) &&
            Number(thisMonthOnly) !== 0 &&
            Number(thisMonthOnly) ===
            Number(displayedWorkspaceCredits) + Number(thisMonthOnly) &&


            <ToolTip
              id="recurring-alert-tooltip"
              label="Increment disabled as there are no more workspace credits left to assign"
              place="left">

                <div className="adjust-credits__value-row__alert__icon">
                  <Icon name="alert" color="goldenTainoi" size={20} className="alert-icon" />
                </div>
              </ToolTip>}

            <NumberChanger
              value={thisMonthOnly}
              onChangeNumber={setThisMonthOnly}
              disableTextInput
              allowNegative
              disabled={isWsFreeTier || workspaceCredits === Infinity}
              decrementDisabled={thisMonthOnly === 0 || isThisMonthOnlyDecrementDisabled}
              max={selectedBucket.teamId ?
              Number(displayedWorkspaceCredits) + Number(thisMonthOnly) :
              Infinity} />


          </div>
        </div>

        <div className="adjust-credits__value-row">
          <Text>Flex</Text>
          <NumberChanger
            value={topUp}
            onChangeNumber={setTopUp}
            disableTextInput
            allowNegative
            decrementDisabled={topUp === 0 || topupCreditDecrementDisabled}
            max={selectedBucket.teamId ? Number(displayedTopUpCredits) + Number(topUp) : Infinity}
            disabled={workspaceCredits === Infinity} />

        </div>
        {hasChangesApartFromRecurring && !teamsOnly &&
        <>
          <Divider className="divider" />
          <Container>
            <Row>
              <LabelWrapper position="left" heading5 label="Is this adjustment related to a project?">
                <Switch
                  onChange={toggleShouldAdjustProject}
                  checked={shouldAdjustProject} />

              </LabelWrapper>
            </Row>
          </Container>
          {shouldAdjustProject &&
          <>
            <Dropdown
              placeholder="Search Project"
              id="projects"
              noResultsText="No matches found"
              onChange={setSelectedProjectForAdjustment}
              options={[]}
              showSelectedSuffix
              loadOptions={fetchProjects}
              isSearchable />

            <Text caption>
              For reference only. Actual credit adjustment will
              be based on the selected Credit Bucket.
            </Text>
          </>}

          <Divider className="divider" />
          <Text required heading5>Specify Reason</Text>
          <div className="radio-group">
            <Container>
              <Row>
                {reasons.map((reason) =>
                <Col xs={12} md={6} lg={6} sm={12} className="col-padding" key={reason.value}>
                    <RadioButton
                    key={reason.value}
                    selected={changeRequest.reason === reason.value}
                    value={reason.value}
                    onChange={() => {
                      setChangeRequest({ ...changeRequest, reason: reason.value });
                    }}>

                      {`${reason.label}`}
                    </RadioButton>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
          <Divider className="divider" />
          <Text heading5>Audit Notes</Text>
          <Input
            id="notes-input"
            multiline
            onChange={(e) => setChangeRequest({ ...changeRequest, notes: e.target.value })}
            placeholder="Enter notes"
            rows={3} />

        </>}

      </div>
    </>);

}